import { render, staticRenderFns } from "./LocationIcon.vue?vue&type=template&id=8dd16710&lang=pug&"
import script from "./LocationIcon.vue?vue&type=script&lang=js&"
export * from "./LocationIcon.vue?vue&type=script&lang=js&"
import style0 from "./LocationIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports